import { axios, API } from './config';

export const menusAPI = {
  getAll: async (eventType = null) => {
    const params = eventType ? { event_type: eventType } : {};
    const response = await axios.get(`${API}/menus`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/menus/${id}`);
    return response.data;
  },
  
  create: async (menuData) => {
    const response = await axios.post(`${API}/menus`, menuData);
    return response.data;
  },
  
  update: async (id, menuData) => {
    const response = await axios.put(`${API}/menus/${id}`, menuData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/menus/${id}`);
    return response.data;
  }
};
